//Course

import axios from 'axios';
import history from '../helpers/history';
import {message} from 'antd';

export function updateURL(url){
  return {
    type: 'UPDATE_URL',
    url: url
  }
}

export function mountLesson(){
  return {
    type: 'MOUNT_LESSON'
  }
}

export function unmountLesson(){
  return {
    type: 'UNMOUNT_LESSON'
  }
}

export function unmountPoem(){
  return {
    type: 'UNMOUNT_POEM'
  }
}

export function completeLesson(nextLesson = false){
  return function(dispatch, getState) {

    const {poet, poem, id} = getState().course.url;
    const { url, length } = getState().course;

    const postUrl = `/api/completions/`,
          params = {poemID: poem, lessonID: id, poetID: poet, value: true, length};
    axios.post(postUrl, params).then((res) => {
      dispatch({
        type: 'COMPLETE_LESSON',
        lessonID: id
      })
      if(nextLesson){
        if(url.id < length){
          const next =  parseInt(url.id, 10) + 1;
          dispatch(changeLesson(next));
        }
      }
    }).catch(err => {
      console.log(err);
    });
  }
}

export function requestCompletions(params) {
  const url = `/api/completions/${params.poet}`;
  const request = axios.get(url);

  return function(dispatch, getState) {
    request.then(function(res) {

      const completions = res.data.poems[params.poem] ? res.data.poems[params.poem].lessons : {};
      const payload = { type: 'REQUEST_COMPLETIONS' };

      if(completions) payload.completions = completions;

      dispatch(payload);

    }).catch((error) => console.log(error));
  }
}

export function removeCompletion(){
  return function(dispatch, getState) {

    const state = getState();
    const {poet, poem, id} = state.course.url;

    const url = `/api/completions/`,
          params = {poemID: poem, lessonID: id, poetID: poet, value: false}
    axios.post(url, params).then((res) => {
      dispatch({
        type: 'REMOVE_COMPLETION',
        lessonID: id
      })
    }).catch(err => {
      console.log(err);
    });
  }
}

//this grabs all data for a poem's course upon mounting
export function requestCourseData(poemID, id) {
  const url = `/api/poems/${poemID}`;
  const request = axios.get(url);

  return function(dispatch) {
    request.then(function(response) {
      const data = response.data;

      const lesson = data.lessons[id],
            info = data.infos[id],
            length = Object.keys(data.lessons).length,
            text = data.text;

      if(!lesson || !info){
        history.push('/404');
        throw new Error('error');
      }

      const url = {poet: data.authorID, poem: poemID, id: id};

      dispatch({
        type: 'REQUEST_COURSE_DATA',
        data, text, lesson, info, length, url
      });

    }).catch((error) => console.log(error));
  };
}

export function requestTutorialData(poemID, id) {
  const url = '/api/tutorial/';
  const request = axios.get(url);

  return function(dispatch) {
    request.then(function(response) {
      const data = response.data;

      const lesson = data.lessons[id],
            info = data.infos[id],
            length = Object.keys(data.lessons).length,
            text = data.text;

      if(!lesson || !info){
        history.push('/404');
        throw new Error('error');
      }

      const url = {poet: data.authorID, poem: poemID, id: id};

      dispatch({
        type: 'REQUEST_COURSE_DATA',
        data, text, lesson, info, length, url
      });

    }).catch((error) => console.log(error));
  };
}

export function fetchUser() {
  const request = axios.get('/api/current_user');

  return function(dispatch){
    request.then((res) => {
      const {password, ...userProps} = res.data;
      const user = res.data._id ? userProps: false;
      dispatch({ type: 'FETCH_USER', user });
    }).catch((error) => console.log(error));
  }
};

export function logOut(){
  window.location.replace('/auth/logout');
  return { type: 'LOGOUT_USER'};
}

export function changeLesson(id){
  return (dispatch, getState) => {
    const { course } = getState();
    const path = [...history.location.pathname.split("/")];
    const currentID = path[4];
    path.pop();
    path.push(id);

    const url = {poet: path[1], poem: path[2], id: path[4]};

    if(course.user && (!currentID || (!course.completions[id-1] && id > currentID && id-1 > 0))){
      message.error("Lesson incomplete");
      dispatch({type: "CHANGE_LESSON_FAILED"})
      return;
    };

    history.push(path.join("/"));

    const lesson = course.data.lessons[id];
    const info = course.data.infos[id];
    dispatch ({
      type: 'CHANGE_LESSON',
      lesson: lesson,
      info: info,
      url: url
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/course.js